import { useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import { BsSearch } from "react-icons/bs";

import { useAuth } from "../../app/useAuth";
import MenuComponent from "../Menu";
import MenuComponentMobile from "../Menu/mobile";

import AlertLogin from "../AlertLogin";
import { Accordion, Form, Button } from "react-bootstrap";
import Banner from "./banner";

export default function MainLayout({
    pathname,
    arrRules,
    header,
    textSearch,
    setTextSearch,
    setSubmitSearch,
    setAdvancedSearch,
    advancedSearchText,
    setAdvancedSearchText,
    exampleText,
}) {
    const auth = useAuth();
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [displayAdvancedSearch, setDisplayAdvancedSearch] = useState(false);
    const [arrRuleDatas, setArrRuleDatas] = useState([]);
    const [checkBoxType, setCheckBoxType] = useState(true);
    const [advancedType, setAdvancedType] = useState("all");
    const [advancedTypeLabel, setAdvancedTypeLabel] = useState("All");
    const [textSearchData, setTextSearchData] = useState(textSearch ? textSearch : "");

    useEffect(() => {
        if (arrRules) {
            setArrRuleDatas(arrRules);
        }
    }, [auth, arrRules]);

    const handleSearch = (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);

        const params = {};

        formData.forEach((v, k) => {
            if (v) {
                params[k] = v;
            }
        });

        if (textSearchData || params) {
            if (auth) {
                const checkAdvancedSearchObject = JSON.stringify(params) === JSON.stringify({});
                if (checkAdvancedSearchObject) {
                    if (textSearchData) {
                        setAdvancedSearchText?.(params);
                        setTextSearch(textSearchData);
                        setSubmitSearch(true);
                    } else {
                        // setShow(true);
                        alert("กรุณากรอกข้อมูลที่จะค้นหา");
                    }
                } else {
                    setAdvancedSearchText(params);
                    setTextSearch(textSearchData);
                    setSubmitSearch(true);
                }
            } else {
                setShow(true);
            }
        } else {
            alert("กรุณากรอกข้อมูลที่จะค้นหา");
        }
    };

    return (
        <div className="pb-5">
            <div className="container">
                <div className="mb-3 h5">{header}</div>

                <div>
                    <Form onSubmit={handleSearch}>
                        <div className="row justify-centent-center align-items-center mb-3">
                            {!displayAdvancedSearch && (
                                <div className="col-12 mt-3">
                                    <div className="input-group">
                                        <input
                                            className="form-control form-control-lg"
                                            type="text"
                                            placeholder="Search"
                                            aria-label=".form-control-lg search Search"
                                            value={textSearchData}
                                            onChange={(e) => setTextSearchData(e.target.value)}
                                        />
                                        <Button variant="light" size="lg" type="submit" style={{ border: "1px solid #ced4da" }}>
                                            <BsSearch />
                                        </Button>
                                    </div>
                                    <div className="font-monospace text-muted p-1">{exampleText}</div>
                                </div>
                            )}

                            {arrRuleDatas && arrRuleDatas.length > 0 && (
                                <Accordion className="mt-3">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Advance Search</Accordion.Header>
                                        <Accordion.Body>
                                            <AdvancedSearch
                                                checkBoxType={checkBoxType}
                                                setCheckBoxType={setCheckBoxType}
                                                advancedType={advancedType}
                                                setAdvancedType={setAdvancedType}
                                                advancedTypeLabel={advancedTypeLabel}
                                                setAdvancedTypeLabel={setAdvancedTypeLabel}
                                                arrRuleDatas={arrRuleDatas}
                                            />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            )}
                        </div>
                    </Form>
                </div>
            </div>
            <AlertLogin show={show} setShow={setShow} />
        </div>
    );
}

function AdvancedSearch({ arrRuleDatas }) {
    return (
        <div style={{ borderRadius: 15 }}>
            {arrRuleDatas &&
                arrRuleDatas.length > 0 &&
                arrRuleDatas.map((item, index) => {
                    return (
                        <div key={index} className="mt-3 my-2">
                            <Form.Group>
                                <Form.Label>{item.title}</Form.Label>
                                <Form.Control type="text" name={item.value} placeholder={`Search...`} />
                            </Form.Group>
                            {/* <div className="row align-items-center">
                                <div className="col-12 col-md-2 d-none d-md-block">
                                    <Form.Control type="text" name={item.title} className="form-control" value={item.title} disabled />
                                </div>
                                <div className="col-12 col-md-10">
                                    <Form.Control type="text" name={item.value} placeholder={`Search...`} />
                                </div>
                            </div> */}
                        </div>
                    );
                })}

            <div className="d-flex flex-column mt-4">
                <Button variant="primary" type="submit">
                    Search
                </Button>
            </div>
        </div>
    );
}
